var MIME_IMAGE = {
    ".gif"  : "image/gif",
    ".jpeg" : "image/jpeg",
    ".jpg"  : "image/jpeg",
    ".png"  : "image/png"
};

function cropImageEdit(id) {
    var editor = document.getElementById(id),
        ctrler = editor.querySelector(".imed-ctrl"),
        sizer = editor.querySelector(".imed-res"),
        img1 = editor.querySelector(".iei1"),
        img2 = editor.querySelector(".iei2"),
        scaler = editor.querySelector(".imed-sca"),
        moving = false,
        uploadName = editor.querySelector(".file-upload-title"),
        uploadFile = editor.querySelector(".file-upload-input"),
        inputEditing = editor.querySelector(".imed-ie"),
        inputDeleting = null;

    var oe = {
        mouseX: 0,
        mouseY: 0,
        imgX: 0,
        imgY: 0,
        baseW: 8,
        baseH: 8,
        cropW: sizer.clientWidth,
        cropH: sizer.clientHeight,
        ratio: sizer.clientWidth / sizer.clientHeight,
        scaleratio: 1,
        scaleby: "width",
        limit: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            minWidth: 8,
            maxWidth: 4000,
            minHeight: 8,
            maxHeight: 4000,
            minScale: 5,
            maxScale: 180
        },
        mediaId: editor.querySelector(".imed-mi").value,
        curSrc: editor.querySelector(".imed-cur").src,
        defSrc: img1.src
    };
    
    function checkFile(e, el) {
        var file = el.files[0],
            ext = file.name.substr(file.name.lastIndexOf(".")).toLowerCase(),
            lang = document.documentElement.lang;
    
        if (!(ext in MIME_IMAGE)) {
            uploadName.value = lang === "fr" ? "Fichier invalid" : "Invalid file";
            return false;
        }
        if (file.size < 160 || file.size > 10485760) {
            uploadName.value = lang === "fr" ? "Fichier est trop large ou trop petit" 
                    : "File is too large or too small";
            return false;
        }
        return true;
    }
    function loadFile(e) {
        if (!checkFile(e, this)) {
            this.value = "";
            $(uploadName).addClass("error");
            return false;
        } else {
            $(uploadName).removeClass("error");
        }
        
        var newImg1 = document.createElement("IMG"),
            newImg2 = document.createElement("IMG");
    
        newImg1.src = newImg2.src = window.URL.createObjectURL(e.target.files[0]);
        newImg1.className = img1.className;
        newImg2.className = img2.className;
        newImg1.onload = function() {
            editor.querySelector(".imed-pho").replaceChild(newImg1, img1);
            sizer.replaceChild(newImg2, img2);
            img1 = newImg1;
            img2 = newImg2;
            toggleMedia(true);
            start();
        };
    }
    
    function start() {
        checkCropArea();
        initImage();
        setScaleLimit();
    }
    function checkCropArea() {
        var zoneW = editor.querySelector(".imed-zo1-inner").clientWidth;
        if (oe.cropW > zoneW) {
            var area = editor.querySelector(".imed-pho");
            area.style.width = zoneW + "px";
            area.style.height = Math.round(zoneW / oe.ratio) + "px";
            oe.scaleratio = zoneW / oe.cropW;
            oe.cropW = zoneW;
            oe.cropH = area.clientHeight;
            scaler.setAttribute("data-min-width", oe.cropW);
            scaler.setAttribute("data-min-height", oe.cropH);
        }
    }
    function initImage() {
        oe.baseW = Math.round(img1.naturalWidth * oe.scaleratio);
        oe.baseH = Math.round(img1.naturalHeight * oe.scaleratio);
        if (oe.baseW / oe.baseH > oe.ratio) {
            oe.scaleby = "height";
            istyle("height", Math.max(oe.baseH, oe.cropH) + "px");
            istyle("width", "");
        } else {
            oe.scaleby = "width";
            istyle("width", Math.max(oe.baseW, oe.cropW) + "px");
            istyle("height", "");
        }
        setPositionLimit();
        imove((oe.cropW - img1.width) / 2, (oe.cropH - img1.height) / 2);
        setPosition();
    }
    
    function setPositionLimit() {
        oe.limit.right = oe.cropW - img1.width;
        oe.limit.bottom = oe.cropH - img1.height;
    }
    function setScaleLimit() {
        var data = $(scaler).data();
        if (!parseInt(data.maxWidth)) data.maxWidth = 4000;
        if (!parseInt(data.maxHeight)) data.maxHeight = 4000;
        
        data.minScale = Math.max(oe.cropW / oe.baseW, oe.cropH / oe.baseH, 0.05) * 100;
        data.minScale = data.minScale.toFixed(4);
        data.maxScale = Math.max(data.minScale, 100) + 80;
        scaler.setAttribute("max", data.maxScale);
        scaler.setAttribute("min", data.minScale);
        scaler.value = Math.max(data.minScale, 100);
        
        Object.assign(oe.limit, data);
    }
    function setPosition() {
        oe.imgX = img1.offsetLeft;
        oe.imgY = img1.offsetTop;
    }
    
    function mdown(e) {
        e.preventDefault();
        e.stopPropagation();
        moving = true;
        var orEv = e.originalEvent || e;
        oe.mouseX = e.pageX || e.clientX || orEv.touches[0].clientX;
        oe.mouseY = e.pageY || e.clientY || orEv.touches[0].clientY;
    }
    function mmove(e) {
        e.preventDefault();
        if (moving) {
            var orEv = e.originalEvent || e;
            var x = e.pageX || e.clientX || orEv.touches[0].clientX;
            var y = e.pageY || e.clientY || orEv.touches[0].clientY;
            imove(oe.imgX + x - oe.mouseX, oe.imgY + y - oe.mouseY);
        }
    }
    function mup(e) {
        e.preventDefault();
        moving = false;
        setPosition();
        iput();
    }
    
    function imove(x, y) {
        if (img1.width >= oe.cropW) {
            istyle("left", within(x, oe.limit.right, oe.limit.left) + "px");
        } else {
            istyle("left", within(x, oe.limit.left, oe.limit.right) + "px");
        }
        if (img1.height >= oe.cropH) {
            istyle("top", within(y, oe.limit.bottom, oe.limit.top) + "px");
        } else {
            istyle("top", within(y, oe.limit.top, oe.limit.bottom) + "px");
        }
    }
    function iresize(e) {
        var w = img1.width,
            h = img1.height,
            nw = within(Math.round(oe.baseW * (scaler.value / 100)), oe.limit.minWidth, oe.limit.maxWidth),
            nh = within(Math.round(oe.baseH * (scaler.value / 100)), oe.limit.minHeight, oe.limit.maxHeight);
        
        if (oe.scaleby === "width") {
            istyle("width", nw + "px");
            istyle("height", "");
        } else {
            istyle("width", "");
            istyle("height", nh + "px");
        }
        setPositionLimit();
        imove(oe.imgX - (nw - w) / 2, oe.imgY - (nh - h) / 2);
        setPosition();
    }
    function istyle(prop, val) {
        img1.style[prop] = img2.style[prop] = val;
    }
    function within(value, min, max) {
        return value < min ? min : value > max ? max : value;
    }
    function iput() {
        editor.querySelector(".imed-ox").value = Math.round(-oe.imgX / oe.scaleratio);
        editor.querySelector(".imed-oy").value = Math.round(-oe.imgY / oe.scaleratio);
        editor.querySelector(".imed-sr").value = scaler.value / 100;
    }
    
    function toggleMedia(active) {
        if (active) {
            $(editor).removeClass("nosrc").removeClass("hascrop");
            inputEditing.value = "true";
        } else {
            $(editor).addClass("nosrc");
            inputEditing.value = "";
            $(uploadFile).val("").change();
            $(uploadName).val("").removeClass("error");
            if (oe.mediaId !== "" && parseInt(oe.mediaId) > 0 && oe.curSrc.length > 1) {
                $(editor).addClass("hascrop");
                $(uploadName).parent().removeClass("error");
            }
        }
    }
    function toggleDelete(active) {
        if (active) {
            inputDeleting = document.createElement("INPUT");
            inputDeleting.type = "hidden";
            inputDeleting.name = "delProfilePic";
            inputDeleting.value = "true";
            editor.appendChild(inputDeleting);
            $(editor).addClass("removal");
        } else {
            if (inputDeleting) {
                editor.removeChild(inputDeleting);
                inputDeleting = null;
            }
            $(editor).removeClass("removal");
        }
    }
    function cancel(e) {
        toggleMedia(false);
    }
    function edit(e) {
        img1.src = img2.src = oe.defSrc;
        setTimeout(function() {
            toggleDelete(false);
            toggleMedia(true);
            start();
        }, 100);
    }
    function remove(e) {
        toggleDelete(!$(editor).hasClass("removal"));
    }
    // In case the container is not displayed, try to reinitiate until the 
    // crop's dimension is calculated.
    function checkSizer() {
        if (sizer.clientHeight > 0 && oe.cropH <= 0 && !oe.ratio) {
            oe.cropW = sizer.clientWidth;
            oe.cropH = sizer.clientHeight;
            oe.ratio = sizer.clientWidth / sizer.clientHeight;
            start();
        } else {
            setTimeout(checkSizer, 1000);
        }
    }
    
    /* Initiate */
    if (img1.width > 0 && img2.width > 0 && oe.cropH > 0 && oe.ratio) {
        start();
    }
    checkSizer();
    
    ctrler.addEventListener("mousedown", mdown);
    ctrler.addEventListener("mousemove", mmove);
    ctrler.addEventListener("mouseup", mup);
    ctrler.addEventListener("mouseout", mup);
    ctrler.addEventListener("touchstart", mdown);
    ctrler.addEventListener("touchmove", mmove);
    ctrler.addEventListener("touchend", mup);
    ctrler.addEventListener("touchcancel", mup);
    scaler.addEventListener("input", iresize);
    scaler.addEventListener("change", iresize); //For IE11
    scaler.addEventListener("change", mup);
    
    uploadFile.addEventListener("change", loadFile);
    
    editor.querySelector(".imed-can").addEventListener("click", cancel);
    editor.querySelector(".imed-mod").addEventListener("click", edit);
    try {
        editor.querySelector(".imed-del").addEventListener("click", remove);
    } catch (ex) {
    }
}


if (window.location.protocol == 'file:') {
    alert('To test this demo properly please use a local server such as XAMPP or WAMP. See README.md for more details.');
}

var resizeableImage = function (image_target_sel, fileInput) {
    // Some variable and settings
    var $container,
            orig_src = new Image(),
            image_target = $(image_target_sel).get(0),
            event_state = {},
            constrain = false,
            min_width = 60, // Change as required
            min_height = 60,
            max_width = 800, // Change as required
            max_height = 900,
            file_input = fileInput,
            resize_canvas = document.createElement('canvas');

    var init = function () {

        // When resizing, we will always use this copy of the original as the base
        orig_src.src = image_target.src;

        // Wrap the image with the container and add resize handles
        $(image_target).wrap('<div class="resize-container"></div>')
                .before('<span class="resize-handle resize-handle-nw"></span>')
                .before('<span class="resize-handle resize-handle-ne"></span>')
                .after('<span class="resize-handle resize-handle-se"></span>')
                .after('<span class="resize-handle resize-handle-sw"></span>');

        // Assign the container to a variable
        $container = $(image_target).parent('.resize-container');

        // Add events
        $container.on('mousedown touchstart', '.resize-handle', startResize);
        $container.on('mousedown touchstart', 'img', startMoving);
        $('.js-crop').on('click', crop);
    };

    startResize = function (e) {
        e.preventDefault();
        e.stopPropagation();
        saveEventState(e);
        $(document).on('mousemove touchmove', resizing);
        $(document).on('mouseup touchend', endResize);
    };

    endResize = function (e) {
        e.preventDefault();
        $(document).off('mouseup touchend', endResize);
        $(document).off('mousemove touchmove', resizing);
    };

    saveEventState = function (e) {
        // Save the initial event details and container state
        event_state.container_width = $container.width();
        event_state.container_height = $container.height();
        event_state.container_left = $container.offset().left;
        event_state.container_top = $container.offset().top;
        event_state.mouse_x = (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) + $(window).scrollLeft();
        event_state.mouse_y = (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) + $(window).scrollTop();

        // This is a fix for mobile safari
        // For some reason it does not allow a direct copy of the touches property
        if (typeof e.originalEvent.touches !== 'undefined') {
            event_state.touches = [];
            $.each(e.originalEvent.touches, function (i, ob) {
                event_state.touches[i] = {};
                event_state.touches[i].clientX = 0 + ob.clientX;
                event_state.touches[i].clientY = 0 + ob.clientY;
            });
        }
        event_state.evnt = e;
    };

    resizing = function (e) {
        var mouse = {}, width, height, left, top, offset = $container.offset();
        mouse.x = (e.clientX || e.pageX || e.originalEvent.touches[0].clientX) + $(window).scrollLeft();
        mouse.y = (e.clientY || e.pageY || e.originalEvent.touches[0].clientY) + $(window).scrollTop();

        // Position image differently depending on the corner dragged and constraints
        if ($(event_state.evnt.target).hasClass('resize-handle-se')) {
            width = mouse.x - event_state.container_left;
            height = mouse.y - event_state.container_top;
            left = event_state.container_left;
            top = event_state.container_top;
        } else if ($(event_state.evnt.target).hasClass('resize-handle-sw')) {
            width = event_state.container_width - (mouse.x - event_state.container_left);
            height = mouse.y - event_state.container_top;
            left = mouse.x;
            top = event_state.container_top;
        } else if ($(event_state.evnt.target).hasClass('resize-handle-nw')) {
            width = event_state.container_width - (mouse.x - event_state.container_left);
            height = event_state.container_height - (mouse.y - event_state.container_top);
            left = mouse.x;
            top = mouse.y;
            if (constrain || e.shiftKey) {
                top = mouse.y - ((width / orig_src.width * orig_src.height) - height);
            }
        } else if ($(event_state.evnt.target).hasClass('resize-handle-ne')) {
            width = mouse.x - event_state.container_left;
            height = event_state.container_height - (mouse.y - event_state.container_top);
            left = event_state.container_left;
            top = mouse.y;
            if (constrain || e.shiftKey) {
                top = mouse.y - ((width / orig_src.width * orig_src.height) - height);
            }
        }

        // Optionally maintain aspect ratio
        if (constrain || e.shiftKey) {
            height = width / orig_src.width * orig_src.height;
        }

        if (width > min_width && height > min_height && width < max_width && height < max_height) {
            // To improve performance you might limit how often resizeImage() is called
            resizeImage(width, height);
            // Without this Firefox will not re-calculate the the image dimensions until drag end
            $container.offset({'left': left, 'top': top});
        }
    };

    resizeImage = function (width, height) {
        resize_canvas.width = width;
        resize_canvas.height = height;
        resize_canvas.getContext('2d').drawImage(orig_src, 0, 0, width, height);
        $(image_target).attr('src', resize_canvas.toDataURL("image/png"));
        file_input.attr("value", orig_src.src);
    };

    startMoving = function (e) {
        e.preventDefault();
        e.stopPropagation();
        saveEventState(e);
        $(document).on('mousemove touchmove', moving);
        $(document).on('mouseup touchend', endMoving);
    };

    endMoving = function (e) {
        e.preventDefault();
        $(document).off('mouseup touchend', endMoving);
        $(document).off('mousemove touchmove', moving);
    };

    moving = function (e) {
        var mouse = {}, touches;
        e.preventDefault();
        e.stopPropagation();

        touches = e.originalEvent.touches;

        mouse.x = (e.clientX || e.pageX || touches[0].clientX) + $(window).scrollLeft();
        mouse.y = (e.clientY || e.pageY || touches[0].clientY) + $(window).scrollTop();
        $container.offset({
            'left': mouse.x - (event_state.mouse_x - event_state.container_left),
            'top': mouse.y - (event_state.mouse_y - event_state.container_top)
        });
        // Watch for pinch zoom gesture while moving
        if (event_state.touches && event_state.touches.length > 1 && touches.length > 1) {
            var width = event_state.container_width, height = event_state.container_height;
            var a = event_state.touches[0].clientX - event_state.touches[1].clientX;
            a = a * a;
            var b = event_state.touches[0].clientY - event_state.touches[1].clientY;
            b = b * b;
            var dist1 = Math.sqrt(a + b);

            a = e.originalEvent.touches[0].clientX - touches[1].clientX;
            a = a * a;
            b = e.originalEvent.touches[0].clientY - touches[1].clientY;
            b = b * b;
            var dist2 = Math.sqrt(a + b);

            var ratio = dist2 / dist1;

            width = width * ratio;
            height = height * ratio;
            // To improve performance you might limit how often resizeImage() is called
            resizeImage(width, height);
        }
    };

    crop = function () {
        //Find the part of the image that is inside the crop box
        var crop_canvas,
                left = $('.overlay-crop').offset().left - $container.offset().left,
                top = $('.overlay-crop').offset().top - $container.offset().top,
                width = $('.overlay-crop').width(),
                height = $('.overlay-crop').height();

        crop_canvas = document.createElement('canvas');
        crop_canvas.width = width;
        crop_canvas.height = height;

        crop_canvas.getContext('2d').drawImage(image_target, left, top, width, height, 0, 0, width, height);
        $(image_target).attr("src", crop_canvas.toDataURL("image/png"));
        left = $('.overlay-crop').offset().left - $container.offset().left;
        top = $('.overlay-crop').offset().top - $container.offset().top;
        $container.css("top", top);
        $container.css("left", left);
        orig_src.src = crop_canvas.toDataURL("image/png");
        file_input.attr("value", orig_src);
    };

    init();
};

// Kick everything off with the target image
//resizeableImage($('.resize-image'));